module.exports = __webpack_public_path__ + "static/media/opinionesJesus.654b631f.jpg";